import { OnInit, Input, Component } from '@angular/core';
import { Sensor } from '@models/sensor';

@Component({
  standalone: false,
  selector: 'app-sensor-icon',
  templateUrl: './sensor-icon.component.html',
  styleUrls: ['./sensor-icon.component.scss']
})
export class SensorIconComponent {
  @Input() type: number;
  @Input() positionVisible: boolean;
  @Input() position: number;
  @Input() size: number = 24;
  @Input() sizeImg: string = 'auto';

  constructor() {
    this.positionVisible = true;
  }

  getSize(): any {
    return {
      'font-size': `${this.size}px`
    };
  }

  getImageSize(): any {
    let h = this.sizeImg;
    if (h != 'auto') {
      h = h + 'px';
    }
    return {
      'height': `${h}`
    };
  }
}